import { ChevronDown, ChevronRight } from "lucide-react";
import React from "react";
import { DocumentMetaBlock } from "@/components/DocumentMetaBlock";

interface StudyNameCellProps {
  studyName: string;
  authors?: string;
  countries?: string;
  year?: string;
  sourceOrganisation?: string;
  status?: string;
  errorMessage?: string;
  filename?: string;
  isParent: boolean;
  isExpanded?: boolean;
  onToggle: () => void;
  actionNode?: React.ReactNode;
}

export const StudyNameCell = ({
  studyName,
  authors,
  countries,
  year,
  sourceOrganisation,
  status,
  errorMessage,
  filename,
  isParent,
  isExpanded,
  onToggle,
  actionNode,
}: StudyNameCellProps) => {
  const Chevron = isExpanded ? ChevronDown : ChevronRight;

  return (
    <div className="flex items-center gap-1.5 w-full">
      {isParent && (
        <button
          onClick={onToggle}
          disabled={isExpanded === undefined}
          className="text-muted-foreground hover:text-foreground shrink-0 disabled:opacity-30 disabled:cursor-default"
        >
          <Chevron className="w-4 h-4" />
        </button>
      )}
      {!isParent && <span className="w-4 shrink-0" />}
      {isParent && (
        <div className="flex-1">
          <p className="font-semibold text-foreground leading-relaxed mb-2">{studyName}</p>
          <DocumentMetaBlock
            filename={filename}
            authors={authors}
            countries={countries}
            year={year}
            sourceOrganisation={sourceOrganisation}
            status={status}
            errorMessage={errorMessage}
          />
        </div>
      )}
      {actionNode && <div className="ml-auto">{actionNode}</div>}
    </div>
  );
};
